import { render, staticRenderFns } from "./make-report.vue?vue&type=template&id=588bada2&"
import script from "./make-report.vue?vue&type=script&lang=js&"
export * from "./make-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports